<template>
    <div>
      <el-form  size="mini" label-width="120px" class="company-form">
        <el-form-item v-if="viewMode==='1'" label="当前已选字段" >
          <!-- <el-tag
              :key="field.id"
              v-for="field in sourceOptions"
              closable
              :disable-transitions="false"
              @close="handleClose(field)"
              >
              {{field.label}}
          </el-tag> -->
          <el-tag
            :key="field.id"
            v-for="field in selectViewSource"
            :disable-transitions="false"
          >
          {{field.label}}
          </el-tag>
        </el-form-item>
        <el-form-item v-if="viewMode==='1'">
          <div  style="float: left"><el-tag effect="plain" type="danger" >可以拖拽移动【字段列表】里的字段进行前后排序，设置好顺序后点击保存设置，列表会按字段顺序进行显示</el-tag></div> 
        </el-form-item>
        <el-form-item label="字段列表" prop="fieldList">
              <!-- <el-select v-model="chooseFields" multiple placeholder="请选择" style="width: 75%;border-radius: 20px;" @change='selectAll'> -->
            <el-drag-select v-model="chooseFields" multiple placeholder="请选择" style="width: 75%;border-radius: 20px;" @change='selectAll'>
                <template v-if="isGroup === true">
                  <el-option-group
                      v-for="group in sourceOptions"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                          v-for="item in group.options"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-option-group>
                </template>
              <template v-else-if="isGroup === false">
                <el-option v-if="viewMode==='1'" v-for="item in allFields" :key="item.id" :label="item.label" :style="getStyle(item)" :value="item.id"></el-option>
                <el-option v-else v-for="item in sourceOptions" :key="item.id" :label="item.label" :style="getStyle(item)" :value="item.id"></el-option>
                  <!-- <el-option  v-for="item in sourceOptions" :key="item.id" :label="item.label" :style="getStyle(item)" :value="item.id"></el-option> -->
              </template>
              <!-- </el-select> -->
            </el-drag-select>
          </el-form-item>
      </el-form>
    </div>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import ElDragSelect from '@/components/DragSelect';
export default {
    components: { ElDragSelect },
    data () {
        return {
            // sourceOptions: [
            //     { id: 'ALL_SELECT', label: 'ALL' },
            //     { id: '1', label: 'liablePerson1' },
            //     { id: '2', label: 'liablePerson2' },
            //     { id: '3', label: 'liablePerson3' },
            //     { id: '4', label: 'liablePerson4' },
            //     { id: '5', label: 'liablePerson5' }
            // ],
            oldOptions: [],
            chooseFields: [],
            selectViewSource: [],
            myMap: new Map(),
            allFieldMap: new Map()
        };
    },
    watch: {
        sourceOptions (val) {
            this.initMap();
        },
        chooseFields (val) {
            if (this.viewMode && this.viewMode === '1' && !isEmpty(val) && !isEmpty(this.allFieldMap)) {
                this.selectViewSource = [];
                for (let i = 0; i < val.length; i++) {
                    this.selectViewSource.push(this.allFieldMap.get(val[i]));
                }
            }
        }
    },
    props: {
        isGroup: {
            type: Boolean,
            default: false
        },
        sourceOptions: { // 外部传入的下拉列表的结构数据
            type: Array
        },
        allFields: { // 外部传入的原始所有字段的结构数据
            type: Array
        },
        selectViewFields: { // 外部传入的下拉列表的结构数据
            type: Array,
            default: () => { return []; }
        },
        viewMode: { // 1：显示字段
            type: String,
            default: null
        }
    },
    created () {
        this.initFields();
    },
    methods: {
        initFields () {
            this.chooseFields = this.selectViewFields;
            this.selectViewSource = cloneDeep(this.sourceOptions);
            if (this.viewMode && this.viewMode === '1') {
                this.allFieldMap = new Map();
                if (!isEmpty(this.allFields)) {
                    this.allFields.forEach((item) => {
                        this.allFieldMap.set(item.id, item);
                    });
                }
            }
            this.myMap = new Map();
        },
        getSelectFields () {
            let selectFields = cloneDeep(this.chooseFields);
            if (selectFields.includes('ALL_SELECT')) {
                selectFields.splice(0, 1); // 排除全选选项
            }
            // console.log(selectFields);
            return selectFields.join(',');
        },
        getSelectViewFields () {
            // let  selectFields=cloneDeep(this.chooseFields);
            if (this.chooseFields.includes('ALL_SELECT')) {
                this.chooseFields.splice(0, 1); // 排除全选选项
            }
            let selectFieldArr = [];
            this.chooseFields.forEach((field) => {
                if (this.myMap.has(field)) {
                    selectFieldArr.push(this.myMap.get(field));
                }
            });
            return selectFieldArr;
        },
        initMap () { // 设置字段的k/v结构
            if (this.isGroup) { // 分组情况
                this.sourceOptions.forEach((item) => {
                    item.options.forEach((child) => {
                        this.myMap.set(child.id, child);
                    });
                });
            }
        },
        selectAll (val) {
            // this.setSelectedNode(val);
            const allValues = [];
            let allSource = [];
            if (this.viewMode && this.viewMode === '1') {
                allSource = this.allFields;
            } else {
                allSource = this.sourceOptions;
            }
            // 保留所有值
            // for (const item of this.sourceOptions) {
            for (const item of allSource) {
                allValues.push(item.id);
            }
            // 用来储存上一次的值，可以进行对比
            const oldVal = this.oldOptions.length === 1 ? this.oldOptions[0] : [];
            // 若是全部选择
            if (val.includes('ALL_SELECT')) {
                this.chooseFields = allValues;
            }
            // 取消全部选中 上次有 当前没有 表示取消全选
            if (oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                this.chooseFields = [];
            }
            // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
            // 新老数据都有全部选中
            if (oldVal.includes('ALL_SELECT') && val.includes('ALL_SELECT')) {
                const index = val.indexOf('ALL_SELECT');
                val.splice(index, 1); // 排除全选选项
                this.chooseFields = val;
            }
            // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
            if (!oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                if (!this.isGroup && val.length === allValues.length - 1) {
                    this.chooseFields = ['ALL_SELECT'].concat(val);
                }
            }
            // 储存当前最后的结果 作为下次的老数据
            this.oldOptions[0] = this.chooseFields;
        },
        getStyle (item) {
            let single = {
                'color': '#333'
            };
            if (item.id === 'appCreatedByName' || item.id === 'appCreatedByDate' || item.id === 'processInstanceName' || item.id === 'createdByName' || item.id === 'createdDate') {
                single.color = '#999';
            }
            return single;
        },
        async handleClose (tag) {
            // let removeTag = this.selectTags.splice(this.selectTags.indexOf(tag), 1);
            // if (removeTag && removeTag[0]) {
            //     this.selectMap.delete(removeTag[0].id);
            //     // if(!removeTag[0].isNew){//非新增的标签时刷新标签树
            //     this.selectedTree = [];
            //     this.selectTags.forEach(item => {
            //         if (!item.isNew) {
            //             this.selectedTree.push(item.id);
            //         }
            //     });
            //     setTimeout(() => {
            //         this.$refs.treeSelect.initParam(this.selectedTree);
            //     }, 0);
            //     // }
            // }
        }
    }
};
</script>

<style>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectMultiple/SelectMultiple.vue